export const loadingSlideKeys = {
  active: (params?: { iataCode?: string }) =>
    ['loading-slides', 'active', params?.iataCode ?? null] as const,
  all: ['loading-slides'] as const,
}
